<template>
  <button
    :class="[buttonClass, { '!bg-[#999] !text-white': isDisabled }]"
    :disabled="isDisabled || isLoading"
    class="text-lg rounded font-bold leading-[normal] p-2.5 transition-all duration-300 ease-in-out"
    @click.prevent="handleClick"
  >
    <transition mode="out-in" name="fade">
      <span v-if="!isLoading" :key="'text'">
        {{ $t(buttonName) }}
        <span v-if="isDisabled && !isWechat">({{ countdown }})</span>
      </span>
      <span v-else :key="'loader'" class="flex items-center justify-center">
        <img alt="" class="w-6 h-6" src="../assets/icons/spin.svg" />
      </span>
    </transition>
  </button>
</template>

<script setup>
import { ref, watch } from 'vue'

const props = defineProps({
  buttonName: {
    type: String,
    required: true
  },
  buttonClass: {
    type: String,
    default:
      'bg-[var(--primary)] text-[var(--text-button)] capitalize shadow-[0px_4px_14px_0px_rgba(0,0,0,0.20)]'
  },
  onClick: Function,
  disabled: {
    type: Boolean,
    default: false
  },
  isLoading: {
    type: Boolean,
    default: false
  },
  isWechat: {
    type: Boolean,
    default: false
  }
})

const countdown = ref(3)
const isDisabled = ref(props.disabled)

const handleClick = () => {
  if (props.onClick()) props.onClick()
}

watch(
  () => props.disabled,
  (val) => {
    if (val) {
      isDisabled.value = true
      countdown.value = 3

      const interval = setInterval(() => {
        countdown.value -= 1

        if (countdown.value <= 0) {
          clearInterval(interval)
          isDisabled.value = false
        }
      }, 1000)
    }
  }
)
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.2s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
</style>
